const WISHLIST_FIELDS_TUNE = `#graphql
  fragment WishlistFieldsTune on Customer {
    wishlist: metafield(namespace: "wish_list", key: "products") {
      ...MetafieldFields
      references(first: 250) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsTune
              ...ProductMetafieldsTune
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantCommonMetafields
                    product { ...ProductFieldsTune }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CUSTOMER_PROFILE_FIELDS_TUNE = `#graphql
  fragment CustomerProfileFieldsTune on Customer {
    ...CustomerBaseFields
    ...WishlistFieldsTune
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
    gender: metafield(namespace: "custom", key: "gender") { ...MetafieldFields }
    birth: metafield(namespace: "custom", key: "birth") { ...MetafieldFields }
  }
`;

const WISHLIST_FIELDS_YESEYESEE = `#graphql
  fragment WishlistFieldsYeseyesee on Customer {
    wishlist: metafield(namespace: "info", key: "wishlist") {
      ...MetafieldFields
      references(first: 250) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              ...ProductMetafieldsYeseyesee
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantCommonMetafields
                    product { ...ProductCommonFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CUSTOMER_PROFILE_FIELDS_YESEYESEE = `#graphql
  fragment CustomerProfileFieldsYeseyesee on Customer {
    ...CustomerBaseFields
    ...WishlistFieldsYeseyesee
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
    gender: metafield(namespace: "info", key: "gender") { ...MetafieldFields }
    birth: metafield(namespace: "info", key: "birth") { ...MetafieldFields }
  }
`;

const WISHLIST_FIELDS_THISISNEVERTHAT = `#graphql
  fragment WishlistFieldsThisisneverthat on Customer {
    wishlist: metafield(namespace: "info", key: "wishlist") {
      ...MetafieldFields
      references(first: 250) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              ...ProductMetafieldsThisisneverthat
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantCommonMetafields
                    product { ...ProductCommonFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CUSTOMER_PROFILE_FIELDS_THISISNEVERTHAT = `#graphql
  fragment CustomerProfileFieldsThisisneverthat on Customer {
    ...CustomerBaseFields
    ...WishlistFieldsThisisneverthat
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
    gender: metafield(namespace: "info", key: "gender") { ...MetafieldFields }
    birth: metafield(namespace: "info", key: "birth") { ...MetafieldFields }
    height: metafield(namespace: "info", key: "height") { ...MetafieldFields }
    weight: metafield(namespace: "info", key: "weight") { ...MetafieldFields }
  }
`;

const WISHLIST_FIELDS_KHAKIS = `#graphql
  fragment WishlistFieldsKhakis on Customer {
    wishlist: metafield(namespace: "info", key: "wishlist") {
      ...MetafieldFields
      references(first: 250) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              ...ProductMetafieldsKhakis
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantCommonMetafields
                    ...VariantMetafieldsKhakis
                    product { ...ProductCommonFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CUSTOMER_PROFILE_FIELDS_KHAKIS = `#graphql
  fragment CustomerProfileFieldsKhakis on Customer {
    ...CustomerBaseFields
    ...WishlistFieldsKhakis
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
    gender: metafield(namespace: "info", key: "gender") { ...MetafieldFields }
    birth: metafield(namespace: "info", key: "birth") { ...MetafieldFields }
  }
`;

const WISHLIST_FIELDS_SUNLOVE = `#graphql
  fragment WishlistFieldsSunlove on Customer {
    wishlist: metafield(namespace: "info", key: "wishlist") {
      ...MetafieldFields
      references(first: 250) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              ...ProductMetafieldsSunlove
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantCommonMetafields
                    product { ...ProductCommonFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CUSTOMER_PROFILE_FIELDS_SUNLOVE = `#graphql
  fragment CustomerProfileFieldsSunlove on Customer {
    ...CustomerBaseFields
    ...WishlistFieldsSunlove
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
    gender: metafield(namespace: "info", key: "gender") { ...MetafieldFields }
    birth: metafield(namespace: "info", key: "birth") { ...MetafieldFields }
  }
`;

const WISHLIST_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment WishlistFieldsWellbeingexpress on Customer {
    wishlist: metafield(namespace: "info", key: "wishlist") {
      ...MetafieldFields
      references(first: 250) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              ...ProductMetafieldsWellbeingexpress
      feature: metafield(namespace: "info", key: "feature") { ...MetafieldFields }
      brandName: metafield(namespace: "info", key: "brand_name") { ...MetafieldFields }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantCommonMetafields
                    product { ...ProductFieldsWellbeingexpress }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CUSTOMER_PROFILE_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CustomerProfileFieldsWellbeingexpress on Customer {
    ...CustomerBaseFields
    ...WishlistFieldsWellbeingexpress
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
    gender: metafield(namespace: "info", key: "gender") { ...MetafieldFields }
    birth: metafield(namespace: "info", key: "birth") { ...MetafieldFields }
  }
`;

/** 이 파일의 모든 fragment (registry 등록용) */
/**
 * tenui 는 위시리스트가 없어 wishlist fragment 를 두지 않는다.
 * (hydrogen 의 CUSTOMER_QUERY 도 id/이름/phone/email/tags/주소만 조회했다)
 */
const CUSTOMER_PROFILE_FIELDS_TENUI = `#graphql
  fragment CustomerProfileFieldsTenui on Customer {
    ...CustomerBaseFields
    defaultAddress { ...MailingAddressFields }
    addresses(first: 250) { edges { node { ...MailingAddressFields } } }
  }
`;

export const CUSTOMER_FRAGMENTS = [
  WISHLIST_FIELDS_TUNE,
  CUSTOMER_PROFILE_FIELDS_TUNE,
  WISHLIST_FIELDS_YESEYESEE,
  CUSTOMER_PROFILE_FIELDS_YESEYESEE,
  WISHLIST_FIELDS_THISISNEVERTHAT,
  CUSTOMER_PROFILE_FIELDS_THISISNEVERTHAT,
  WISHLIST_FIELDS_KHAKIS,
  CUSTOMER_PROFILE_FIELDS_KHAKIS,
  WISHLIST_FIELDS_SUNLOVE,
  CUSTOMER_PROFILE_FIELDS_SUNLOVE,
  WISHLIST_FIELDS_WELLBEINGEXPRESS,
  CUSTOMER_PROFILE_FIELDS_WELLBEINGEXPRESS,
  CUSTOMER_PROFILE_FIELDS_TENUI,
];
